import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";

//fx obtener logs
export const getLogs = async (
	Start: Date,
	End: Date,
	Search: string,
	LogTypeCode: number | string | null,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "Start", value: Start });
	parameters.push({ name: "End", value: End });
	parameters.push({ name: "Search", value: Search });
	parameters.push({
		name: "LogTypeCode",
		value: LogTypeCode === "A" ? null : LogTypeCode,
	});

	const resp = await apiService.callV2("[MES].[GetLogs]", parameters);
	return resp;
};
